const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const OrderCountView = require('app/restaurant/stat/OrderCountView');
const CAView = require('app/restaurant/stat/CAView');
const ProductCARankView = require('app/restaurant/stat/ProductCARankView');
const ProductVolumeRankView = require('app/restaurant/stat/ProductVolumeRankView');
const RangeCARankView = require('app/restaurant/stat/RangeCARankView');
const SupplierCARankView = require('app/restaurant/stat/SupplierCARankView');

class StatTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitForm = this.onSubmitForm.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    loadData(){
        var self = this;

        this.$resultContainer
        .html('')
        .append(window.App.generateLoader())

        let queries = [
            this.buildRestaurantStatisticQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildResult(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildRestaurantStatisticQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'restaurant': id,
            'from': this.$inputFrom.val(),
            'to': this.$inputTo.val(),
        };

        let fields = [
            'ordersCountByMonth { x y }',
            'netSaleByMonth { x y }',
            'netSaleProductRank { netSale product { id number reference }}',
            'volumeProductRank { volume product { id number reference unit } }',
            'netSaleRangeRank { range { id name } netSale }',
            'netSaleSupplierRank { supplier { id name } netSale }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantStatistic',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildTab(){

        this.$resultContainer = $('<div/>');

        this.$content = $('<div/>')
        .append(this.buildForm())
        .append(this.$resultContainer);


        this.$container
        .html('')
        .append(this.$content);

        this.$form.trigger('submit');
    }

    buildForm(){
        let begin = moment().startOf('year').format('YYYY-MM-DD');
        let end = moment().endOf('year').format('YYYY-MM-DD');

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-info')
        .append(
            $('<i/>')
            .addClass('far fa-search')
        );

        this.$form = $('<form/>')
        .addClass('restaurant-analyse-form')
        .addClass('white-box')
        .on("submit",this.onSubmitForm);

        let $row = $('<div/>')
        .addClass('row');

        this.$inputFrom = $('<input/>')
        .attr('id','analyseFrom')
        .attr('type','date')
        .attr('name','analysePeriodBegin')
        .addClass('form-control')
        .attr('required','required')
        .val(begin);

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('from'))
                    )
                    .append(this.$inputFrom)
                )
            )
        );

        this.$inputTo = $('<input/>')
        .attr('id','analyseTo')
        .attr('type','date')
        .attr('name','analysePeriodEnd')
        .addClass('form-control')
        .attr('required','required')
        .val(end);

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('to'))
                    )
                    .append(this.$inputTo)
                )
            )
        );

        $row.append(
            $('<div/>')
            .addClass('col-2 p-2 mt-auto')
            .append(this.$btnSubmit)
        );

        this.$form
        .addClass('d-flex justify-content-center')
        .append($row);

        return this.$form;
    }

    onSubmitForm(event){
        event.preventDefault();
        event.stopPropagation();
        
        this.loadData();
    }

    buildResult(data){

        this.restaurantStatistic = data.restaurantStatistic;

        this.ordersCountByMonth = this.restaurantStatistic.ordersCountByMonth;
        this.netSaleByMonth = this.restaurantStatistic.netSaleByMonth;
        this.netSaleProductRank = this.restaurantStatistic.netSaleProductRank;
        this.volumeProductRank = this.restaurantStatistic.volumeProductRank;
        this.netSaleRangeRank = this.restaurantStatistic.netSaleRangeRank;
        this.netSaleSupplierRank = this.restaurantStatistic.netSaleSupplierRank;

        this.$orderCountContainer = $('<div/>')
        .addClass('white-box');
        this.$caViewContainer = $('<div/>')
        .addClass('white-box');
        this.$productCARankContainer = $('<div/>')
        .addClass('white-box');
        this.$productVolumeRankContainer = $('<div/>')
        .addClass('white-box');
        this.$rangeCARankContainer = $('<div/>')
        .addClass('white-box');
        this.$supplierCARankContainer = $('<div/>')
        .addClass('white-box');

        this.$resultContainer
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$caViewContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$orderCountContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$productCARankContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$productVolumeRankContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$rangeCARankContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$supplierCARankContainer)
            )
        );
        
        this.orderCountView = new OrderCountView({
            '$container': this.$orderCountContainer,
            'data': this.ordersCountByMonth
        });

        this.caView = new CAView({
            '$container': this.$caViewContainer,
            'data': this.netSaleByMonth

        });

        this.productCARankView = new ProductCARankView({
            '$container': this.$productCARankContainer,
            'data': this.netSaleProductRank

        });

        this.productVolumeRankView = new ProductVolumeRankView({
            '$container': this.$productVolumeRankContainer,
            'data': this.volumeProductRank
        });
        

        this.rangeCARankView = new RangeCARankView({
            '$container': this.$rangeCARankContainer,
            'data': this.netSaleRangeRank

        });

        this.supplierCARankView = new SupplierCARankView({
            '$container': this.$supplierCARankContainer,
            'data': this.netSaleSupplierRank
        });
    }
}

module.exports = StatTab;

